module.exports = __webpack_public_path__ + "img/team_management.fd324fea.png";